import { render } from "./NewLogin.vue?vue&type=template&id=f0259d72&scoped=true"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"

import "./NewLogin.vue?vue&type=style&index=0&id=f0259d72&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0259d72"]])

export default __exports__